import { render, staticRenderFns } from "./DashboardElementRecommendations.vue?vue&type=template&id=73687d29&scoped=true&"
import script from "./DashboardElementRecommendations.vue?vue&type=script&lang=js&"
export * from "./DashboardElementRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73687d29",
  null
  
)

export default component.exports